module.exports = __webpack_public_path__ + "img/entertainment-5.ccca85c8.jpg";